import { observable, action } from 'mobx'
import request from 'app/vendor/request'
import config from 'app/config'
import { message } from 'antd'

export default class Store {
  @observable groupId = ""
  @observable recoveryTableData = []
  @observable tableData = []
  @observable list
  @observable detailData = {}

  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/azf/groups/${groupId}/reports?state=${query}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.recoveryTableData = res
        }
      )
  }

  @action clearRecoveryTableData = () => {
    this.recoveryTableData = []
  }

  @action setGroupId = (id) => {
    this.groupId = id
  }

  @action initTableData = (reportId) => {
    if(reportId === '1'){
      var Url=`${config.backend}/azf/mut/default/query`
    }else{
      var Url=`${config.backend}/azf/mut/detail/query/${this.groupId}`
    }
    return request.get(Url)
      .checkToken()
      .commonDispose()
  }
  @action saveDatas = (newData) => {

    if(!newData.id){
      var Url=`${config.backend}/azf/mut/add`
    }else{
      var Url=`${config.backend}/azf/mut/save`
    }
    return request.post(Url)
      .send(newData)
      .checkToken()
      .commonDispose()
  }

  @action updateTableData = (data) => {
    this.tableData = data
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/azf/reports/${reportId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action clearDetailData = () => {
    this.detailData = {}
  }

  static fromJS() {
    const store = new Store()
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/research/azf/report.js